export default __webpack_public_path__ + "static/media/SueloVerde.0a645cfb.png";